@if (filterForm() != null) {
    <h2 class="header">Eiendomstype</h2>

    <div class="toggle-button">
        <div class="toggle-left" [class.active]="!filterForm().isSitePrice().value()" (click)="setSitesOnly(false)">Boliger</div>
        <div class="toggle-right" [class.active]="filterForm().isSitePrice().value()" (click)="setSitesOnly(true)">Tomter</div>
    </div>

    <div class="header-wrapper">
    <h2 class="header">Utvalg</h2>
    <div class="info-tooltip no-bottom" (click)="showPeriodHelper = !showPeriodHelper" (clickOutside)="showPeriodHelper = false">
        <ev_tooltip
            [visible]="showPeriodHelper"
            [title]="selectedOption() === 'Registered' ? 'Registrert' : selectedOption() === 'Sold' ? 'Solgt' : 'I markedet'"
            [zIndex]="2"
            [left]="-78"
            [top]="24"
            [arrowAlignLeft]="79"
            [arrowTopAlign]="-8"
            [arrow]="'top'"
            (close)="showPeriodHelper = false"
            [width]="360"
        >
            <market-statistics-helper [searchViewOptions]="viewOptions()"></market-statistics-helper>
        </ev_tooltip>
    </div>
    </div>

    <div class="period-selector">
        <div class="option in-market" [class.active]="selectedOption() === 'InMarket'" (click)="selectOption('InMarket')">
            <div class="period-icon in-market"></div>
            <div>I markedet</div>
        </div>
        <div class="option registered" [class.active]="selectedOption() === 'Registered'" (click)="selectOption('Registered')">
            <div class="period-icon registered"></div>
            <div>Registrert</div>
        </div>
        <div class="option sold" [class.active]="selectedOption() === 'Sold'" (click)="selectOption('Sold')">
            <div class="period-icon sold"></div>
            <div>Solgt</div>
        </div>
    </div>

    <h2 class="header">Type salg</h2>

    <div class="list-container">
        <ul>
            <li class="check-box" (click)="toggleJudicialTransfers(filterForm().includeJudicialTransfers().value())">
                <input
                    type="checkbox"
                    class="checkbox-icon"
                    [formField]="filterForm().includeJudicialTransfers"
                    [class.selected]="filterForm().includeJudicialTransfers().value()"
                />
                <label>Vis tinglysninger</label>
                <div
                    class="info-tooltip"
                    (click)="showJudicialTransferTooltip = !showJudicialTransferTooltip"
                    (clickOutside)="showJudicialTransferTooltip = false"
                >
                    <ev_tooltip
                        [visible]="showJudicialTransferTooltip"
                        [bottom]="24"
                        [right]="-149"
                        [arrow]="'bottom'"
                        [width]="296"
                        [arrowBottomAlign]="-8"
                        [arrowAlignRight]="150"
                    >
                        <div class="tooltip-content">Eiendommer med tinglyst hjemmelsovergang, der det ikke er benyttet eiendomsmegler i salgsprosessen.</div>
                    </ev_tooltip>
                </div>
            </li>
            <li class="check-box" (click)="toggleAgentSales(filterForm().includeAgentSales().value())">
                <input
                    type="checkbox"
                    class="checkbox-icon"
                    [formField]="filterForm().includeAgentSales"
                    [class.selected]="filterForm().includeAgentSales().value()"
                />
                <label>Vis meglersalg</label>
                <div class="info-tooltip" (click)="showMarketSalesTooltip = !showMarketSalesTooltip" (clickOutside)="showMarketSalesTooltip = false">
                    <ev_tooltip
                        [visible]="showMarketSalesTooltip"
                        [bottom]="24"
                        [right]="-161"
                        [arrow]="'bottom'"
                        [width]="296"
                        [arrowBottomAlign]="-8"
                        [arrowAlignRight]="162"
                    >
                        <div class="tooltip-content">Eiendommer lagt ut for salg eller solgt, der det er benyttet eiendomsmegler i salgsprosessen.</div>
                    </ev_tooltip>
                </div>
            </li>
            @if (hasShowEstateAgentCompanySales() && user) {
                <li
                    [class.disabled]="filterForm().includeOnlyEstateAgencySales().disabled()"
                    class="check-box"
                    (click)="toggleEstateAgencySales(filterForm().includeOnlyEstateAgencySales().value())"
                >
                    <input
                        type="checkbox"
                        class="checkbox-icon"
                        [formField]="filterForm().includeOnlyEstateAgencySales"
                        [class.selected]="filterForm().includeOnlyEstateAgencySales().value()"
                    />
                    <label>Vis kun salg fra {{getEstateAgentName(user)}}</label>
                </li>
            }
            <li
                [class.disabled]="filterForm().isForSale().disabled()"
                class="check-box"
                (click)="toggleForSaleOnly(filterForm().isForSale().value())"
            >
                <input type="checkbox" class="checkbox-icon" [formField]="filterForm().isForSale" [class.selected]="filterForm().isForSale().value()" />
                <label>Kun til salgs nå</label>
            </li>
            <li
                [class.disabled]="filterForm().includeWithDrawnPrices().disabled()"
                class="check-box"
                (click)="toggleWithDrawnPrices(filterForm().includeWithDrawnPrices().value())"
            >
                <input
                    type="checkbox"
                    class="checkbox-icon"
                    [formField]="filterForm().includeWithDrawnPrices"
                    [class.selected]="filterForm().includeWithDrawnPrices().value()"
                />
                <label>Kun salg som er trukket</label>
                <div class="info-tooltip" (click)="showWithdrawnTooltip = !showWithdrawnTooltip" (clickOutside)="showWithdrawnTooltip = false">
                    <ev_tooltip
                        [visible]="showWithdrawnTooltip"
                        [bottom]="32"
                        [right]="-75"
                        [arrow]="'bottom'"
                        [width]="310"
                        [arrowBottomAlign]="-8"
                        [arrowAlignRight]="76"
                    >
                        <div class="tooltip-content">
                            Salg som er trukket gjelder for salgsprosesser hvor en bolig er lagt ut for salg i markedet, men senere trukket.
                        </div>
                    </ev_tooltip>
                </div>
            </li>
            <li class="check-box" (click)="toggleOwnedByCompany(filterForm().isOwnedByCompany().value())">
                <input
                    type="checkbox"
                    class="checkbox-icon"
                    [formField]="filterForm().isOwnedByCompany"
                    [class.selected]="filterForm().isOwnedByCompany().value()"
                />
                <label>Salg som involverer selskap (AS)</label>
                <div
                    class="info-tooltip"
                    (click)="showIsOwnedByCompanyTooltip = !showIsOwnedByCompanyTooltip"
                    (clickOutside)="showIsOwnedByCompanyTooltip = false"
                >
                    <ev_tooltip
                        [visible]="showIsOwnedByCompanyTooltip"
                    [bottom]="32"
                        [right]="-75"
                        [arrow]="'bottom'"
                        [width]="310"
                        [arrowBottomAlign]="-8"
                        [arrowAlignRight]="76"
                    >
                        <div class="tooltip-content">Eiendommer der dagens hjemmelshaver er et selskap (AS).</div>
                    </ev_tooltip>
                </div>
            </li>
            <li class="check-box" (click)="toggleUncertainPrice(filterForm().includeUnCertainPrices().value())">
                <input
                    type="checkbox"
                    class="checkbox-icon"
                    [formField]="filterForm().includeUnCertainPrices"
                    [class.selected]="filterForm().includeUnCertainPrices().value()"
                />
                <label>Inkluder spesielle omsetninger</label>
                <div class="info-tooltip" (click)="showUncertainPriceTooltip = !showUncertainPriceTooltip" (clickOutside)="showUncertainPriceTooltip = false">
                    <ev_tooltip
                        [visible]="showUncertainPriceTooltip"
                        [bottom]="24"
                        [right]="-52"
                        [arrow]="'bottom'"
                        [width]="292"
                        [arrowBottomAlign]="-8"
                        [arrowAlignRight]="53"
                    >
                        <div class="tooltip-content">
                            Spesielle omsetninger er omsetninger der Eiendomsverdi ikke med sikkerhet vet om det er et reelt markedssalg. Et eksempel på dette
                            er at prisen er svært lav eller svært høy for boligtypen i dette området.
                        </div>
                    </ev_tooltip>
                </div>
            </li>

            @if (filterForm().includeUnCertainPrices().value()) {
                <div class="filter-description">Spesielle omsetninger vises som grå i kart og lister</div>
            }
        </ul>
    </div>
}
